export const TISA = '"ff-tisa-web-pro", Palatino, TimesNewRoman, "Times New Roman", Times, Baskerville, Georgia, serif';
export const MONTSERRAT = 'Montserrat, "Open Sans", Arial, "Helvetica Neue", Helvetica, sans-serif';